/** Emergency contacts client — family-scoped CRUD. */
import { api } from './client';

export type Relationship =
  | 'parent'
  | 'guardian'
  | 'grandparent'
  | 'aunt_uncle'
  | 'sibling'
  | 'friend'
  | 'neighbour'
  | 'other';

export interface EmergencyContact {
  id: string;
  family_id: string;
  name: string;
  relationship: Relationship;
  phone: string;
  email: string | null;
  priority: number;
  notify_on_sos: boolean;
  notify_on_battery_low: boolean;
  notify_on_geofence_exit: boolean;
  created_at: string;
  updated_at: string;
}

export type EmergencyContactCreate = Omit<EmergencyContact, 'id' | 'family_id' | 'created_at' | 'updated_at'>;
export type EmergencyContactUpdate = Partial<EmergencyContactCreate>;

export const emergencyApi = {
  list: () => api<EmergencyContact[]>('/v1/families/me/emergency-contacts'),
  create: (input: EmergencyContactCreate) =>
    api<EmergencyContact>('/v1/families/me/emergency-contacts', {
      method: 'POST',
      body: input,
    }),
  update: (id: string, input: EmergencyContactUpdate) =>
    api<EmergencyContact>(`/v1/families/me/emergency-contacts/${id}`, {
      method: 'PATCH',
      body: input,
    }),
  remove: (id: string) =>
    api<void>(`/v1/families/me/emergency-contacts/${id}`, { method: 'DELETE' }),
};
